import { render, staticRenderFns } from "./ItemCardList.vue?vue&type=template&id=397c69f1&"
import script from "./ItemCardList.vue?vue&type=script&lang=js&"
export * from "./ItemCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports